/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_TitleInputs */

const en_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integration Settings`)
};

const fr_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres d'intégration`)
};

const de_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrationseinstellungen`)
};

const it_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di integrazione`)
};

const ru_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки интеграции`)
};

const es_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de integración`)
};

const zh_cn2_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集成设置`)
};

const ja_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統合設定`)
};

const hi_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एकीकरण सेटिंग्स`)
};

const pt_pt2_options_integrations_title = /** @type {(inputs: Options_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de integração`)
};

/**
* | output |
* | --- |
* | "Integration Settings" |
*
* @param {Options_Integrations_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_title = /** @type {((inputs?: Options_Integrations_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_integrations_title(inputs)
	if (locale === "de") return de_options_integrations_title(inputs)
	if (locale === "it") return it_options_integrations_title(inputs)
	if (locale === "ru") return ru_options_integrations_title(inputs)
	if (locale === "es") return es_options_integrations_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_integrations_title(inputs)
	if (locale === "ja") return ja_options_integrations_title(inputs)
	if (locale === "hi") return hi_options_integrations_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_integrations_title(inputs)
	return en_options_integrations_title(inputs)
});